import { AcquiringDetail, Refund, PaymentStep, Capture } from '@/classes/models'

export default class Payment {
  /**
   * Create new payment and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map refunds to Refund
    if (typeof this.refunds !== 'undefined') {
      this.refunds = this.refunds.map(refund => new Refund(refund))
    }

    // Map steps to PaymentStep
    if (typeof this.steps !== 'undefined') {
      this.steps = this.steps.map(step => new PaymentStep(step))
    }

    // Map captures to Capture
    if (typeof this.captures !== 'undefined') {
      this.captures = this.captures.map(capture => new Capture(capture))
    }

    if (typeof this.attributes.cashFlowsAcquiringDetails !== 'undefined') {
      this.acquiringDetails = new AcquiringDetail(JSON.parse(this.attributes.cashFlowsAcquiringDetails))
    }
  }

  /**
   * @return {Date}
   */
  get createDateTimeUtc () {
    return this._createDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set createDateTimeUtc (value) {
    this._createDateTimeUtc = new Date(value)
  }

  /**
   * @return {string}
   */
  get originatingIpAddress () {
    if (this._originatingIpAddress) {
      return this._originatingIpAddress
    }

    if (!this.attributes || !this.attributes.originatingIpAddress) {
      return null
    }

    return this.attributes.originatingIpAddress
  }

  /**
   * @param {string} value
   */
  set originatingIpAddress (value) {
    this._originatingIpAddress = value
  }
}
